<template>
  <div
    :class="[
      { 'text-black': color === 'black' },
      { 'text-white': color === 'white' },
    ]"
    class="fixed right-0 top-0 z-10 h-full w-container-desktop max-lg:hidden"
  >
    <div class="flex h-full flex-col items-center justify-end">
      <div class="mb-[22svh] w-[40svh] -rotate-90 text-label-lg font-semibold uppercase tracking-[.35em]">
        {{ text }}
      </div>
      <div class="mb-[15svh]">
        <div class="relative flex w-10 flex-col">
          <button
            :disabled="back <= 0"
            type="button"
            class="group"
            @click="goToElementFromNumber(back)"
          >
            <svg
              :class="back <= 0 ? 'opacity-20' : ''"
              class="transition-all duration-500 group-hover:-translate-y-1"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.5 21L11.5 4M11.5 4L7 8.78519M11.5 4L16 8.78519"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
              />
            </svg>

            <div
              class="w-full text-center text-body-2xl font-medium transition-opacity duration-500"
              :class="back <= 0 ? `opacity-20` : ''"
            >
              {{ back+1 }}
            </div>
          </button>
          <svg
            viewBox="0 0 24 2"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path ref="deviderLine" d="M0 1H24" stroke="currentColor" />
          </svg>

          <button
            type="button"
            :disabled="forward > elements.length"
            class="group"
            @click="goToElementFromNumber(forward)"
          >
            <div
              class="w-full text-center text-body-2xl font-medium transition-opacity duration-500"
              :class="forward > elements.length ? 'opacity-20' : ''"
            >
              {{ elements.length }}
            </div>

            <svg
              :class="forward > elements.length ? 'opacity-20' : ''"
              class="transition-all duration-500 group-hover:translate-y-1"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.5 4L11.5 21M11.5 21L16 16.2148M11.5 21L7 16.2148"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
              />
            </svg>
          </button>
        </div>
      </div>
      <a
        target="_blank"
        :href="downloadHref"
        class="group mb-8 rounded-full border-2 border-current p-3 hover:border-transparent"
        :class="[
          { 'hover:bg-blue-500': color === 'black' },
          { 'hover:bg-white': color === 'white' },
        ]"
      >
        <Suspense>
          <UiDownload class="w-8" :color="color" :text="downloadText" />
        </Suspense>
      </a>
    </div>
  </div>
</template>

<script lang="ts" setup>
const deviderLine = useTemplateRef('deviderLine')
const { y } = useWindowScroll()
const number = ref(0)

const props = defineProps<{
  color: 'black' | 'white'
  elements: {
    el: HTMLElement
    top: number
  }[]
  index: number
  downloadText: string
  entry: any
}>()

const entry = computed(() => {
  return props.entry
})

const downloadHref = computed(() => {
  return toRaw(entry.value?.file_financial_statement)?.permalink
})

const offset = computed(() => {
  return deviderLine.value?.getBoundingClientRect().top
})

const back = computed(() => {
  return number.value - 1
})

const forward = computed(() => {
  return number.value + 1
})

const text = computed(() => {
  // header
  if (number.value === 1) {
    return entry.value?.sidebar_title || entry.value?.title
  }
  if (!Array.isArray(entry.value?.components_br)) {
    return
  }

  return entry.value?.components_br[(number.value - 2)]?.sidebar_title
})

watch(y, () => {
  calcNumber()
})
onMounted(() => {
  nextTick(() => {
    calcNumber()
  })
})

function goToElementFromNumber(number: number) {
  const element = props.elements[number - 1]
  if (element) {
    element.el.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    })
  }
}

function calcNumber() {
  number.value = 0
  props.elements.forEach((element) => {
    const { top } = element.el.getBoundingClientRect()
    if (top < offset.value!) {
      number.value += 1
    }
  })
}
</script>
